import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { SOARResources } from "../services/soar";
import FloatingInput from "../common/FloatingInput";

function NewResidenceProgramModal({
  data,
  setData,
  show,
  handleSave,
  onHide,
  programType,
}) {
  const [options, setOptions] = useState({});
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const stateResponse = await SOARResources({
      command: "query",
      environment:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "SOARQueryLive"
          : "SOARQueryBase",
      resource: "company",
      keyword: "viewall",
    });

    if (stateResponse.code === "success") {
      const puResp = await SOARResources({
        command: "query",
        environment:
          process.env.REACT_APP_ENVIRONMENT === "Production"
            ? "SOARQueryLive"
            : "SOARQueryBase",
        keyword: "viewall",
        resource: "programunit",
      });
      if (puResp.code === "success") {
        const puOptions = puResp.data
          .filter(
            (unit) =>
              !unit.ccx_expdate &&
              unit.programtype?.name.toLowerCase() === programType.toLowerCase()
          )
          .sort((a, b) => a.ccx_name.localeCompare(b.ccx_name))
          .map((unit) => ({
            _id: unit.ccx_unitid.replaceAll("{", "").replaceAll("}", ""),
            name: unit.ccx_name,
            state: unit.unit_state,
          }));
        setOptions({
          ...options,
          programUnits: puOptions,
          states: stateResponse.data,
        });
      }
    }
  };

  return (
    <Modal show={show} onHide={onHide} animation={false} size="lg">
      <Modal.Header closeButton className="bg-safy-info text-white">
        <Modal.Title>Home Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FloatingInput
          type="select"
          name="programUnit"
          label="Program Unit"
          options={options.programUnits}
          value={data.programUnit?.id || ""}
          onChange={(e) => {
            const selectedPU = options.programUnits?.find(
              (pu) => pu._id === e.target.value
            );
            const selectedState = options.states?.find((state) =>
              state.name.includes(selectedPU?.state)
            );
            setData({
              ...data,
              programUnit: selectedPU
                ? { id: selectedPU._id, name: selectedPU.name }
                : { id: "", name: "" },
              state: selectedState
                ? { id: selectedState.id, name: selectedState.name }
                : { id: "", name: "" },
            });
          }}
        />
        <FloatingInput
          type="select"
          name="numberOfBeds"
          label="Number of Beds"
          options={Array.from({ length: 30 }, (_, i) => ({
            _id: (i + 1).toString(),
            name: (i + 1).toString(),
          }))}
          value={data.numberOfBeds || ""}
          onChange={(e) => setData({ ...data, numberOfBeds: e.target.value })}
        />
      </Modal.Body>
      <Modal.Footer className="bg-safy2-4">
        <button
          className="btn btn-sm btn-success"
          onClick={() => handleSave()}
          disabled={!data.programUnit?.id || !data.numberOfBeds}
        >
          Save
        </button>
        <button className="btn btn-sm btn-danger" onClick={onHide}>
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default NewResidenceProgramModal;
